import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {environment} from "../../environments/environment";
import Pagination from "../../model/pagination";
import DunModel from "../../model/dun.model";
import QueryEncoder from "../queryEncoder";
import {catchError, switchMap} from "rxjs/operators";
import InvoiceModel from "../../model/invoice.model";
import ActionService from "../action.service";

@Injectable()
export default class DunService {
    public constructor(private http: HttpClient, private actionService: ActionService) {
    }
    public show(id: number): Observable<DunModel> {
        return this.http.get<DunModel>(environment.apiUrl + '/duns/' + id);
    }

    public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additionalFields?: any): Observable<Pagination<DunModel>> {
        if(typeof query !== 'string') {
            query = '';
        }
        query = query || '';
        page = page || 1;
        limit = limit || 15;
        sort = sort || '';

        let sorting = {};
        sorting[sort] = direction;

        const q = {query, page, limit, sorting};

        if(additionalFields) {
            Object.assign(q, additionalFields);
        }

        return this.http.get<Pagination<DunModel>>(environment.apiUrl + '/duns?' + QueryEncoder.encodeURI(q));
    }

    public delete(dun: DunModel): Observable<boolean> {
        return this.http.delete(environment.apiUrl + '/duns/' + dun.id).pipe(switchMap(result => of(true)), catchError(err => of(false)));
    }

    public createDun(invoice: InvoiceModel): Observable<DunModel> {
        return this.actionService.execute<DunModel>('generate-dun', {
            invoice_id: invoice.id
        });
    }

    public escalateDun(dun: DunModel): Observable<DunModel> {
        return this.actionService.execute<DunModel>('escalate-dun', {
            dun_id: dun.id
        });
    }

    public update(dun: DunModel): Observable<any> {
        return this.http.put(environment.apiUrl + '/duns/' + dun.id, dun);
    }
}
